import type { FC } from 'react';
import { useEffect } from 'react';
import { BillListBold } from 'solar-icons';
import { Button } from '@/DesignSystem/Component';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
import SubscriptionTransactionId from '@/Module/Subscription/Component/TransitionHistory/SubscriptionTransactionId';
import TransactionEmpty from '@/Module/Subscription/Component/TransitionHistory/TransactionEmpty';
import { getTransactionUserAction } from '@/Module/Subscription/Store/Action';
import { transactionUserSelectIds } from '@/Module/Subscription/Store/Selector';
import { transactionNextPageAction } from '@/Module/Subscription/Store/Slice/SubscriptionSlice';
const TransitionHistory: FC = () => {
  const dispatch = useAppDispatch();
  const ids = useAppSelector(transactionUserSelectIds);
  const isLoading = useAppSelector(state => state.subscription.transactionUser.isLoading);
  const total = useAppSelector(state => state.subscription.transactionUser.total);
  const page = useAppSelector(state => state.subscription.transactionUser.page);
  const showMore = total > ids.length;
  useEffect(() => {
    dispatch(getTransactionUserAction({
      Pagination: true,
      SortOrder: 'ID DESC'
    }));
  }, [page]);
  const onNextClick = () => {
    dispatch(transactionNextPageAction());
  };
  if (!ids.length) return <TransactionEmpty />;
  return <div data-sentry-component="TransitionHistory" data-sentry-source-file="TransitionHistory.tsx">
      <div>
        <div className="flex flex-row ">
          <BillListBold className="ml-2 text-blackSix" data-sentry-element="BillListBold" data-sentry-source-file="TransitionHistory.tsx" />
          <div className="font-semibold text-blackFive ">تراکنش های من</div>
        </div>
        <div className="mt-2 text-sm text-blackThree">
          در این بخش می‌توانید سوابق پرداخت‌ها و خریدهای خود را مشاهده کنید. همه‌ی تراکنش‌های شما به ترتیب تاریخ در دسترس
          هستند تا مدیریت مالی حساب‌تان آسان‌تر باشد.{' '}
        </div>
      </div>
      <div className="flex w-full">
        <div className=" mt-8 grid w-full grid-cols-1 gap-4 sm:gap-8 lg:grid-cols-2">
          {ids.map(id => <SubscriptionTransactionId key={id} id={id} />)}
        </div>
      </div>

      {showMore && <div className="mb-12 flex  ">
          <Button isLoading={isLoading} onClick={onNextClick} className="mr-0 mt-8" variant="shadow" color="BLUE" size="large" bold>
            مشاهده بیشتر تراکنش ها
          </Button>
        </div>}
    </div>;
};
export default TransitionHistory;